import { Command } from 'ckeditor5/src/core';
import { isWidget } from 'ckeditor5/src/widget';
export default class SetIsOpenCommand extends Command {
    /**
     * Executes the command.
     *		// Toggles current state
     *		editor.execute( 'setIsOpen' );
     *
     *		// Sets the state to open
     *		editor.execute( 'setIsOpen', { isOpen: true } );
     *		editor.execute( 'setIsOpen', { isOpen: 'true' } );
     *
     *		// Removes the width attribute / collapses / minimizes:
     *		editor.execute( 'setIsOpen', { isOpen: false } );
     *		editor.execute( 'setIsOpen', { isOpen: 'false' } );
     *
     * @param {Object} options
     * @param {String|null} options.isOpen The state of the file's expansion
     * @fires execute
     */
    execute(options) {
        const selection = this.editor.model.document.selection;
        const editor = this.editor;
        const model = editor.model;
        // const selectedElement = this.getClosestSelectedFileWidget( selection );
        const selectedElement = selection.getSelectedElement();
        if (selectedElement) {
            model.change(writer => {
                if (options.isOpen) {
                    if (typeof options.isOpen == 'boolean') {
                        writer.setAttribute('fileIsOpen', options.isOpen ? 'true' : 'false', selectedElement);
                    }
                    else {
                        writer.setAttribute('fileIsOpen', options.isOpen, selectedElement);
                    }
                }
                else {
                    const currentValue = selectedElement.getAttribute('fileIsOpen');
                    writer.setAttribute('fileIsOpen', currentValue === 'true' ? 'false' : 'true', selectedElement);
                }
            });
        }
    }
    refresh() {
        this.isEnabled = true;
    }
    isFileWidget(viewElement) {
        return viewElement.name === 'file' && isWidget(viewElement);
    }
    getClosestSelectedFileWidget(selection) {
        const selectionPosition = selection.getFirstPosition();
        if (!selectionPosition) {
            return null;
        }
        const viewElement = selection.getSelectedElement();
        if (viewElement && this.isFileWidget(viewElement)) {
            return viewElement;
        }
        let parent = selectionPosition.parent;
        while (parent) {
            if (parent && parent.is('element') && this.isFileWidget(parent)) {
                return parent;
            }
            if (parent.parent) {
                parent = parent.parent;
            }
            else {
                break;
            }
        }
        return null;
    }
}
